import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionRRH } from './components/SolutionRRH';
import { ThreeAnchors } from './components/ThreeAnchors';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Audience } from './components/Audience';
import { Transformation } from './components/Transformation';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen font-sans antialiased text-[#1a1f3a] bg-[#faf8f5]" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionRRH data-id="element-3" />
      <ThreeAnchors data-id="element-4" />
      <WhatsIncluded data-id="element-5" />
      <Audience data-id="element-6" />
      <Transformation data-id="element-7" />
      <Pricing data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}